// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".on-topic-no-picture{padding-top:1rem;padding-bottom:1rem}.on-topic-no-picture:hover{cursor:pointer}.on-topic-no-picture .content{display:inline;padding:0px}.on-topic-no-picture .content h4{font-family:Roboto Slab, Georgia, serif;font-size:1.125rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
